var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "col-xs-12 col-sm-6 col-md-4": _vm.widgetTrackplusFlag } },
    [
      _c("div", { class: _vm.widgetTrackplusFlag ? "widget-1" : "" }, [
        _vm.panel && _vm.panel.active
          ? _c("h3", { staticClass: "title" }, [
              _c("img", {
                staticClass: "track_plus_icon_blue",
                attrs: { src: "/static/images/icons/track_plus_icon_blue.svg" },
              }),
              _c("span", [_vm._v("Summary")]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "col-md-12 col-xs-12 summary_row" }, [
          _c("div", { staticClass: "summary col-md-12 col-xs-12" }, [
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "col-xs-11 cursor-pointer heading",
                on: {
                  click: function ($event) {
                    return _vm.goToLink("/layout/registration")
                  },
                },
              },
              [
                _vm._v(" Registrations "),
                _c("div", { staticClass: "heading_count" }, [
                  _vm._v(_vm._s(_vm.registrationCount)),
                ]),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "col-md-12 col-xs-12 summary_row" }, [
          _c("div", { staticClass: "summary col-md-12 col-xs-12" }, [
            _vm._m(1),
            _c(
              "div",
              {
                staticClass: "col-xs-11 cursor-pointer heading",
                on: {
                  click: function ($event) {
                    return _vm.goToLink("/layout/report/device")
                  },
                },
              },
              [
                _vm._v(" Devices "),
                _c("div", { staticClass: "heading_count" }, [
                  _vm._v(_vm._s(_vm.devicesCount)),
                ]),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "col-md-12 col-xs-12 summary_row" }, [
          _c("div", { staticClass: "summary col-md-12 col-xs-12" }, [
            _vm._m(2),
            _c(
              "div",
              {
                staticClass: "col-xs-11 cursor-pointer heading",
                on: {
                  click: function ($event) {
                    return _vm.goToLink("/layout/report/country")
                  },
                },
              },
              [
                _vm._v(" Countries "),
                _c("div", { staticClass: "heading_count" }, [
                  _vm._v(_vm._s(_vm.countriesCount)),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "div-img" }, [
      _c("img", {
        staticClass: "summary_registration",
        attrs: { src: "/static/images/icons/summary_registration.svg" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "div-img" }, [
      _c("img", {
        staticClass: "summary_registration",
        attrs: { src: "/static/images/icons/summary_devices.svg" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "div-img" }, [
      _c("img", {
        staticClass: "summary_registration",
        attrs: { src: "/static/images/icons/summary_country.svg" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }